import { Injectable } from '@angular/core';
import { QueryParamsInterface } from '@interfaces/global/query.params.interface';
import { AbstractService } from '@services/abstract/abstract.service';

import { FindAssetPurchasesBuyConfigInterface } from '@interfaces/configurations/find-asset-purchases-buy-config.interface';
import { FindAssetPurchasesSellConfigInterface } from '@interfaces/configurations/find-asset-purchases-sell-config.interface';
import { FindAssetWithdrawalsConfigInterface } from '@interfaces/configurations/find-asset-withdrawals-config.interface';

@Injectable()
export class ConfigurationsPurchaseService extends AbstractService<
  FindAssetPurchasesBuyConfigInterface,
  QueryParamsInterface
> {
  protected errorsSection = 'errors.configurations';
  protected endPoint = '/configurations/assets/%s/purchases/buy';
}

@Injectable()
export class ConfigurationsSellService extends AbstractService<
  FindAssetPurchasesSellConfigInterface,
  QueryParamsInterface
> {
  protected errorsSection = 'errors.configurations';
  protected endPoint = '/configurations/assets/%s/purchases/sell';
}

@Injectable()
export class ConfigurationsWithdrawalService extends AbstractService<
  FindAssetWithdrawalsConfigInterface,
  QueryParamsInterface
> {
  protected errorsSection = 'errors.configurations';
  protected endPoint = '/configurations/assets/%s/withdrawals';
}
